{
  "alert": "Warnhinweis",
  "dismiss": "Schließen"
}